export default "__VITE_ASSET__Dfmgl$cD__"